import {useMemo} from 'react'
import {makeSelectResidentsByOccupancy} from '../../Utils/residentUtils'
import {useSelector} from 'react-redux'

/**
 * @param {string} occupancyId
 * @param {boolean?} includePast
 */
function useGetResidentsByOccupancy(occupancyId, includePast = false) {
  const selectorByUnit = useMemo(() => makeSelectResidentsByOccupancy(occupancyId, includePast), [occupancyId, includePast])
  return useSelector(selectorByUnit)
}

export default useGetResidentsByOccupancy
